import { useAuth0 } from '@auth0/auth0-react';

/**
 * Logs out of Auth0.
 * Deletes Auth0 session data from localStorage
 * Deletes Userservice session token from localStorage
 * Logs out of Auth0 session via http
 * Redirects user to login page when done via auth0.logout()
 */
const useLogout = () => {
  const auth0 = useAuth0();

  /**
   * Clears Auth0 entries from localStorage
   */
  function clearAuth0FromLocalStorage() {
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith('@@auth0')) {
        localStorage.removeItem(key);
      }
    }
  }

  function logout() {
    // Clear Auth0 entries from localStorage
    clearAuth0FromLocalStorage();

    // Clear Userservice session token from localStorage
    localStorage.removeItem('session');

    // Log out of Auth0
    auth0.logout({
      logoutParams: { returnTo: window.location.origin },
    });
  }

  return { logout, clearAuth0FromLocalStorage };
};

export default useLogout;
